import { createHeadlessEditor } from "@lexical/headless";
import { EDITOR_THEME } from "../theme/theme";
import { EDITOR_NODES_HEADLESS } from "./nodes-headless";

import type { TableCellNodeSupercedement } from "./use-styleable-columns";
import type { LexicalEditor } from "lexical";

export const createConfiguredEditor = (
  config: {
    onError?: (error: Error) => void;
    format: "email" | "chat" | "sms";
  },
  nodesSuperceder: TableCellNodeSupercedement = (nodes) => nodes,
): LexicalEditor =>
  createHeadlessEditor({
    nodes: nodesSuperceder(EDITOR_NODES_HEADLESS[config.format]),
    theme: EDITOR_THEME,
    onError: config.onError,
  });
